import { createSelector } from 'reselect';

export const companiesSelector = (state) => state.companies;

export const selectedCompanySelector = createSelector(
    companiesSelector,
    (companies) => companies.selectedCompany,
);

export const selectedCompanyCompanySelector = createSelector(
    selectedCompanySelector,
    (selectedCompany) => selectedCompany.company,
);
